import Vue from 'vue'
import VueRouter from 'vue-router'
import App from './App.vue'
import treatment from './view/treatment.vue'
import treatmentList from './view/treatmentList.vue'

Vue.use(VueRouter)
let routers = {
    routes: [
        {
            path: '/',
            component: App,
            children: [
                {
                    path: '',
                    redirect: '/home/133',
                    name: 'home'
                },
                {
                    path: '/home/:marketId',
                    component: treatment,
                    name: 'home'
                },
                {
                    path: '/treatmentList/:marketId',
                    component: treatmentList,
                    name: 'treatmentList'
                }
            ]
        },
    ],
    mode: 'hash',
    strict: false
}

const router = new VueRouter(routers)
const title = {
    home: {title: '首页', limit: 'noPath'},
    treatmentList: {title: '兑换信息', limit: 'noPath'},
}

router.beforeEach(function (to, from, next) {
    if (to.query.activitySource) {
        if (!localStorage.getItem('firstEnterTime')) {
            localStorage.setItem('firstEnterTime', new Date().getTime())
            if (!localStorage.getItem('activitySource') && !localStorage.getItem('activeId')) {
                localStorage.setItem('activitySource', to.query.activitySource)
                localStorage.setItem('activeId', to.query.activeId)
            }
        } else {
            let firstTime = parseInt(localStorage.getItem('firstEnterTime'))
            let now = new Date().getTime()
            let timeDiff = Math.floor((now - firstTime) / (1000 * 60 * 60))
            if (timeDiff > 30) {
                localStorage.setItem('activitySource', '')
                localStorage.setItem('activeId', '')
            }
        }
    }
    let path = to.path
    let pastPage = site.getLocal('current')
    //添加页面标题
    document.title = title[to.name].title
    //设置上一页缓存
    localStorage.setItem('referrers', window.location.href)
    //判断页面是否需要登陆
    if (title[to.name] && title[to.name].limit == 'login' && !site.isLogin()) {
        if (Prius && Prius.isInsideApp) {
            Prius.login()
        } else {
            router.go('#/' + title[to.name].limit)
        }
    }
    ////判断页面是否纪录历史
    if (title[to.name] && title[to.name].limit == 'noPath') {
        next()
        return
    }
    if (pastPage != undefined && (path != pastPage)) {
        site.getLocal('referrer', pastPage)
    }
    site.getLocal('current', path)
    next()
})


export default router



// WEBPACK FOOTER //
// ./src/routers.js